import React from 'react';

// Components
import Link from 'components/common/Link';
import Text from 'components/common/Text';

// Libs
import Translation from 'libs/Translation';

const Description = () => {
    
    const items = [
        {id: 0, title: Translation.t('title.desc-1'), text: Translation.t('text.desc-1')},
        {id: 1, title: Translation.t('title.desc-2'), text: Translation.t('text.desc-2')},
        {id: 2, title: Translation.t('title.desc-3'), text: Translation.t('text.desc-3')}
    ]

    return ( 
    <div className='description'>
        {items.map(i => (
            <div 
                key={i.id}
            >
                <Text
                    tag="h4"
                >
                    {i.title}
                </Text>
                <Text
                    tag="p"
                >
                    {i.text}
                </Text>
            </div>
        ))}
    </div>
    )
}

export default Description;
